module.exports = "<div *ngIf=\"message\" class=\"m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible\" role=\"alert\">\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"></button>\n\t<span>{{message.text}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/probox-dev/src/app/auth/_directives/alert.component.html
// module id = ../../../../../src/app/auth/_directives/alert.component.html
// module chunks = main